import React, { useState } from 'react';
import { AlertTriangle, LogOut } from 'lucide-react';

// Reads the non-httpOnly cookies set by the SA /impersonate endpoint so we
// can render a persistent banner inside AppLayout. On stop we POST to the
// stop endpoint (clears all impersonation cookies) and redirect back to
// the SA console.
function readCookie(name) {
  const match = document.cookie.split('; ').find(c => c.startsWith(`${name}=`));
  return match ? decodeURIComponent(match.split('=').slice(1).join('=')) : null;
}

export default function ImpersonationBanner() {
  const [stopping, setStopping] = useState(false);
  const active = readCookie('impersonation_active');
  if (!active) return null;

  const targetName = readCookie('impersonated_user_name') || 'this user';
  const saEmail = readCookie('impersonator_email') || 'support';

  const stop = async () => {
    setStopping(true);
    try {
      const API = process.env.REACT_APP_BACKEND_URL;
      await fetch(`${API}/api/superadmin/impersonate/stop`, { method: 'POST', credentials: 'include' });
    } catch {}
    window.location.href = '/superadmin/dashboard';
  };

  return (
    <div
      className="w-full bg-amber-500 text-slate-900 px-4 py-2 flex items-center justify-between gap-3 text-sm shadow-sm"
      data-testid="impersonation-banner"
    >
      <div className="flex items-center gap-2 min-w-0">
        <AlertTriangle className="w-4 h-4 flex-shrink-0" />
        <span className="truncate">
          You are logged in as <strong>{targetName}</strong> · Super Admin session (<code className="font-mono text-[12px]">{saEmail}</code>)
        </span>
      </div>
      <button
        onClick={stop}
        disabled={stopping}
        className="flex items-center gap-1.5 px-3 py-1 rounded-md bg-slate-900 text-white text-xs font-medium hover:bg-slate-800 disabled:opacity-50"
        data-testid="impersonation-stop"
      >
        <LogOut className="w-3 h-3" /> {stopping ? 'Stopping…' : 'Stop Impersonating'}
      </button>
    </div>
  );
}
